import React from "react";
import { Footer } from "@govtechsg/sgds-react/Footer";
import { Container } from "react-bootstrap";
import Constant from "../../../constants";
import moment from "moment";

const CaasFooter = React.forwardRef((props, ref) => {
  const year = moment(new Date()).format('YYYY');
  return (
    <Footer>
      <Footer.Top>
        <Container>
          <Footer.Top.Header className="ss-footer-title"
            headerTitle={Constant.SKYSAFE}
          ></Footer.Top.Header>
          <Footer.Top.ItemGroup>
            <Footer.Top.Item itemTitle={Constant.APPLY_FOR_OTHER_SERVICE}>
              <a href={Constant.GO_BUSINESS}>GoBusiness</a>
            </Footer.Top.Item>
          </Footer.Top.ItemGroup>
          <Footer.Top.ContactLinks>
            <a href={Constant.CONTACT_US}>Contact Us</a>
            <a href={Constant.FEED_BACK} aria-label={Constant.FEED_BACK_ALT} target="_blank" rel="noopener noreferrer">
              Feedback
            </a>
            <a href={Constant.FAQs} aria-label={Constant.FAQs_ALT} target="_blank" rel="noopener noreferrer">FAQs</a>
            <a href={Constant.USEFUL_LINKS}>Useful Links</a>
          </Footer.Top.ContactLinks>
        </Container>
      </Footer.Top>
      <Footer.Bottom>
        <Container>
          <hr />
          <Footer.Bottom.Links>
            <a
              href={Constant.REPORT_VULNER}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={Constant.REPORT_VULNER_ALT}
            >
              Report Vulnerability
            </a>
            <a href={Constant.PRIVACY_STATEMENT} aria-label={Constant.PRIVACY_STATEMENT_ALT} >Privacy</a>
            <a href={Constant.TERMS_OF_USE} aria-label={Constant.TERMS_OF_USE_ALT}>Terms of Use</a>
            <a href={Constant.REACH_LINK} aria-label={Constant.REACH_LINK_ALT} target="_blank" rel="noopener noreferrer">REACH</a>


          </Footer.Bottom.Links>
          <Footer.Bottom.Copyrights>
            © {year} Government of Singapore
            <br></br>
            {Constant.FOOTER_LAST_UPDATED_DATE_TEXT}
          </Footer.Bottom.Copyrights>
        </Container>
      </Footer.Bottom>
    </Footer>
  );
});

export default CaasFooter;
